import {PlayerBase} from "../../player/player.base";
import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError} from "rxjs/operators";
import {CachingService} from "../../services/caching/caching.service";
import {Log, LogTag} from "../../services/Log";
import {PlayerBaseService} from "../../services/PlayerService/player.base.service";
import {PlayerPwaService} from "../../services/PlayerService/player.pwa.service";

@Component({
  selector: 'app-image',
  template: '<div #component (click)="onClick($event)"></div>',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageComponent extends PlayerBase {
  genericElm: GenericElm;
  resourceId;
  onSvgClick;
  finalized = false;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  getElementPath(elm) {
    const svgElm = this.component.nativeElement.firstElementChild;
    let child = elm;
    let path = "";
    while(child!=svgElm) {
      const parent = child.parentElement;
      let index = Array.prototype.indexOf.call(parent.children, child);
      path = (path=="") ? String(index) : index + "." + path;
      child = parent;
    }
    return path
  }

  load(playerObject: any): Observable<any> {
    //if (this.parentPlayer.playerObject.$.id=="7" || this.parentPlayer.playerObject.$.id==16) {
    //  return of(this);
    //}

    const logInfo = Log.getLogInfo("ImageComponent", "load", []);
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        if (this.data==null) {
          Log.debug();
        }

        try {
          self = playerBase;
          if (this.data == '') {
            Log.w(logInfo, LogTag.PLAYER, 'ImageComponent have corrupted data');
            return of(null); //??? happend in: r1@ms.com, scene 161
          }

          if (this.genericElm == null) {
            this.genericElm = new GenericElm(this.component);

            //if (this.editMode) {
            /*???
            this.onSvgClick = (item) => {
              const path = this.getElementPath(item.target);
              const svg = {name: 'svg', event: 'select', target: item.target, path: path};
              this.playerService.studioChannel$.next(svg);
            }
            this.component.nativeElement.addEventListener('click', this.onSvgClick);

             */
            //}
          }
          if (this.data.Resource == null) {
            Log.debug();
          }
          this.resourceId = this.data.Resource[0].$.resource;
          if (this.data.Resource[0].Svg != null) {
            this.genericElm.svg = {};
            if (this.data.Resource[0].Svg[0]?.Item != null) {
              this.data.Resource[0].Svg[0].Item.forEach(item => {
                this.genericElm.svg[item.$.path] = {fill: item.$.fill, stroke: item.$.stroke};
              });
            }
          }
          return (<CachingService>this.playerService.caching).getResource(this.resourceId)
        } catch (e) {
          Log.debug();
        }
      }),
      switchMap( path => {
        try {
          if (this.data==null) {
            Log.debug();
            return of(null);
          }
          if (path == null) {
            return of('empty')
          }
          let aspectRatio = false;
          if (this.data.Resource == null) {
            Log.debug();
          }
          if (this.data.Resource[0].AspectRatio != null) {
            aspectRatio = this.data.Resource[0].AspectRatio[0].$.maintain == "1";
          }
          return this.genericElm.setImage(path, aspectRatio, this.actualWidth, this.actualHeight);
        } catch (e) {
          Log.debug();
        }
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }


  addContent(statTag, statField, duration) {
    this.playerService.stats.addContent(statTag, 0, this.resourceId, duration);
  }

  destroy(): void {
    if (this.onSvgClick!=null) {
      this.component.nativeElement.removeEventListener('click', this.onSvgClick);
      this.onSvgClick = null;
    }

    if (this.genericElm != null) {
      this.genericElm.destroy();
    }
    super.destroy();
  }
}
